import locale77c06943 from '../../lang/nl.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"nl"},
  vueI18nLoader: false,
  locales: [{"code":"nl","file":"nl.js","name":"nl","iso":"nl"},{"code":"en","file":"en.js","name":"en","iso":"en"}],
  defaultLocale: "nl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/app/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://omarasieraden.nl",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"nl","file":"nl.js","name":"nl","iso":"nl"},{"code":"en","file":"en.js","name":"en","iso":"en"}],
  localeCodes: ["nl","en"],
  additionalMessages: [],
}

export const localeMessages = {
  'nl.js': () => Promise.resolve(locale77c06943),
  'en.js': () => import('../../lang/en.js' /* webpackChunkName: "lang-en.js" */),
}
